import React, { useState, useEffect, useRef, useMemo } from "react";
import LoaderIndex from "~/containers/LoaderIndex";
import { Link } from "../Elements";
import { InstagramEmbed, YouTubeEmbed } from 'react-social-media-embed';
import { facebookAppId } from "~/config/socialMedia";
const tasrTVVideaURL = "https://www.youtube.com/c/TASRTV";
const terazIgURL = "https://www.instagram.com/terazsk/";
const TerazFBUrl = "https://www.facebook.com/teraz.sk";
const tasrFBUrl = "https://www.facebook.com/AgenturaTASR";
const tasrIgURL = "https://www.instagram.com/tasr_thenewsagency/";
const terazSCURL = "https://soundcloud.com/terazsk";
const terazThreadsURL = "https://www.threads.net/@terazsk";

/** `post.php` height query (hint). Actual iframe height follows Facebook `postMessage` resize. */
const FB_EMBED_URL_HEIGHT_HINT = 480;
const FB_EMBED_PAD_PX = 20;
const FB_ORIGIN_RE = /^https:\/\/(www\.facebook\.com|web\.facebook\.com|m\.facebook\.com)/;
const FB_RELAXED_MIN_PARSED_HEIGHT = 220;

function getFacebookPluginWidth(): number {
    if (typeof window === "undefined") {
        return 700;
    }
    return window.innerWidth <= 768 ? Math.max(window.innerWidth - 50, 280) : 700;
}

function buildFacebookPostPluginSrc(postUrl: string, width: number): string {
    return `https://www.facebook.com/plugins/post.php?href=${encodeURIComponent(postUrl)}&show_text=true&width=${width}&height=${FB_EMBED_URL_HEIGHT_HINT}&appId=${facebookAppId}&locale=sk_SK`;
}

function messageSourceFromOurFacebookIframe(
    source: MessageEvent["source"],
    iframeEl: HTMLIFrameElement | null
): boolean {
    if (!iframeEl?.contentWindow || source == null || typeof source !== "object" || !(source instanceof Window)) {
        return false;
    }
    const targetWin = iframeEl.contentWindow;
    const src = source as Window;
    if (src === targetWin) {
        return true;
    }
    let w: Window | null = src;
    for (let depth = 0; depth < 10 && w; depth++) {
        try {
            w = w.parent;
        } catch {
            break;
        }
        if (!w) {
            break;
        }
        if (w === targetWin) {
            return true;
        }
        if (typeof window !== "undefined" && w === window) {
            return false;
        }
    }
    return false;
}

function parseFacebookPluginResizeHeight(data: unknown): number | null {
    if (data == null) {
        return null;
    }
    if (Array.isArray(data)) {
        let best = 0;
        for (const v of data) {
            if (typeof v === "number" && Number.isFinite(v) && v > best) {
                best = v;
            }
        }
        if (best > 50) {
            return best;
        }
    }
    if (typeof data === "number" && Number.isFinite(data) && data > 50) {
        return data;
    }
    if (typeof data === "string") {
        const trimmed = data.trim();
        if (/^\d+$/.test(trimmed)) {
            const h = parseInt(trimmed, 10);
            return Number.isFinite(h) && h > 50 ? h : null;
        }
        try {
            return parseFacebookPluginResizeHeight(JSON.parse(trimmed));
        } catch {
            return null;
        }
    }
    if (typeof data === "object") {
        const o = data as Record<string, unknown>;
        for (const key of ["method", "type"] as const) {
            if (o[key] === "resize") {
                const rh = o.height;
                if (typeof rh === "number" && Number.isFinite(rh)) {
                    return rh;
                }
                if (typeof rh === "string") {
                    const h = parseInt(rh, 10);
                    return Number.isFinite(h) ? h : null;
                }
            }
        }
        for (const key of ["height", "frameHeight", "frame_height"] as const) {
            const raw = o[key];
            if (typeof raw === "number" && Number.isFinite(raw) && raw > 50) {
                return raw;
            }
            if (typeof raw === "string") {
                const h = parseInt(raw, 10);
                if (Number.isFinite(h) && h > 50) {
                    return h;
                }
            }
        }
        for (const key of ["payload", "data"] as const) {
            const raw = o[key];
            if (raw != null && typeof raw === "object") {
                const inner = parseFacebookPluginResizeHeight(raw);
                if (inner != null) {
                    return inner;
                }
            }
        }
    }
    return null;
}

// import LoaderIndex from "../../containers/LoaderIndex"


const SpotifyPlayer = ({ embedUrl }) => {

    useEffect(() => {
        if (process.env.BUILD_TARGET !== "server") {
            (window as any).onSpotifyIframeApiReady = (IFrameAPI) => {
                const element = document.getElementById('spotify-embed-iframe');
                const options = {
                    uri: 'spotify:episode:' + embedUrl
                };
                const callback = (EmbedController) => {};
                IFrameAPI.createController(element, options, callback);
            };
        }
    }, []);

    return (
        <div id="spotify-embed-iframe"></div>
    );
  };

  


const AgregatorSocSietiPage = (props) => {
  
    const [searchResults, setSearchResults] = useState([]);
    const [searchVideoResults, setSearchVideoResults] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchVideoTerm, setSearchVideoTerm] = useState('');

    const [embeddedFbPost, setEmbeddedFbPost] = useState('');
    const [embeddedIgPost, setEmbeddedIgPost] = useState('');
    const [embeddedYtPost, setEmbeddedYtPost] = useState('');
    const [embeddedSpotifyPost, setEmbeddedSpotifyPost] = useState('');
    const [showPopup, setShowPopup] = useState(false);
    const [showSearchPopup, setShowSearchPopup] = useState(false);


    const [activeVideoFilter, setActiveVideoFilter] = useState('');
    const [activePostFilter, setActivePostFilter] = useState('');
    const [socialData, setSocialData] = useState();
    
    const [ytByViews, setYtByViews] = useState([]);
    const [ytByViewsPage, setYtByViewsPage] = useState(0);
    const [ytByViewsHasMore, setYtByViewsHasMore] = useState(true);
    const [ytByViewsLoading, setYtByViewsLoading] = useState(false);
    const ytByViewsRef = useRef(null);

    const [ytByDate, setYtByDate] = useState([]);
    const [ytByDatePage, setYtByDatePage] = useState(0);
    const [ytByDateHasMore, setYtByDateHasMore] = useState(true);
    const [ytByDateLoading, setYtByDateLoading] = useState(false);
    const ytByDateRef = useRef(null);

    const [spotifyByDate, setSpotifyByDate] = useState([]);
    const [spotifyByDatePage, setSpotifyByDatePage] = useState(0);
    const [spotifyByDateHasMore, setSpotifyByDateHasMore] = useState(true);
    const [spotifyByDateLoading, setSpotifyByDateLoading] = useState(false);
    const spotifyByDateRef = useRef(null);

    const [instagramByDate, setInstagramByDate] = useState([]);
    const [instagramByDatePage, setInstagramByDatePage] = useState(0);
    const [instagramByDateHasMore, setInstagramByDateHasMore] = useState(true);
    const [instagramByDateLoading, setInstagramByDateLoading] = useState(false);
    const instagramByDateRef = useRef(null);

    const [facebookByDate, setFacebookByDate] = useState([]);
    const [facebookByDatePage, setFacebookByDatePage] = useState(0);
    const [facebookByDateHasMore, setFacebookByDateHasMore] = useState(true);
    const [facebookByDateLoading, setFacebookByDateLoading] = useState(false);
    const facebookByDateRef = useRef(null);

    const [facebookByStateInstitution, setFacebookByStateInstitution] = useState([]);
    const [facebookByStateInstitutionPage, setFacebookByStateInstitutionPage] = useState(0);
    const [facebookByStateInstitutionHasMore, setFacebookByStateInstitutionHasMore] = useState(true);
    const [facebookByStateInstitutionLoading, setFacebookByStateInstitutionLoading] = useState(false);
    const facebookByStateInstitutionRef = useRef(null);

    const [youtubeByDateNonParlamentary, setYoutubeByDateNonParlamentary] = useState([]);
    const [youtubeByDateNonParlamentaryPage, setYoutubeByDateNonParlamentaryPage] = useState(0);
    const [youtubeByDateNonParlamentaryHasMore, setYoutubeByDateNonParlamentaryHasMore] = useState(true);
    const [youtubeByDateNonParlamentaryLoading, setYoutubeByDateNonParlamentaryLoading] = useState(false);
    const youtubeByDateNonParlamentaryRef = useRef(null);

    const [facebookByDateNonParlamentary, setFacebookByDateNonParlamentary] = useState([]);
    const [facebookByDateNonParlamentaryPage, setFacebookByDateNonParlamentaryPage] = useState(0);
    const [facebookByDateNonParlamentaryHasMore, setFacebookByDateNonParlamentaryHasMore] = useState(true);
    const [facebookByDateNonParlamentaryLoading, setFacebookByDateNonParlamentaryLoading] = useState(false);
    const facebookByDateNonParlamentaryRef = useRef(null);

    const [instagramByDateNonParlamentary, setInstagramByDateNonParlamentary] = useState([]);
    const [instagramByDateNonParlamentaryPage, setInstagramByDateNonParlamentaryPage] = useState(0);
    const [instagramByDateNonParlamentaryHasMore, setInstagramByDateNonParlamentaryHasMore] = useState(true);
    const [instagramByDateNonParlamentaryLoading, setInstagramByDateNonParlamentaryLoading] = useState(false);
    const instagramByDateNonParlamentaryRef = useRef(null);

    // Cache of fetched pages to avoid duplicate HTTP requests when multiple columns need the same page
    const pageCache = useRef(new Map<number, any>());
    const pendingFetches = useRef(new Map<number, Promise<any>>());


    const [searchTermNonParlamentary, setSearchTermNonParlamentary] = useState('');
    const [searchResultsNonParlamentary, setSearchResultsNonParlamentary] = useState([]);

    const [facebookIframeHeight, setFacebookIframeHeight] = useState(FB_EMBED_URL_HEIGHT_HINT);
    const facebookPostIframeRef = useRef<HTMLIFrameElement | null>(null);
    const facebookResizeMaxRef = useRef(0);

    const facebookPostPlugin = useMemo(() => {
        if (process.env.BUILD_TARGET === "server" || !embeddedFbPost) {
            return null;
        }
        const w = getFacebookPluginWidth();
        return {
            src: buildFacebookPostPluginSrc(embeddedFbPost, w),
            width: w,
        };
    }, [embeddedFbPost, showPopup]);

    useEffect(() => {
        setFacebookIframeHeight(FB_EMBED_URL_HEIGHT_HINT);
        facebookResizeMaxRef.current = 0;
    }, [embeddedFbPost]);

    useEffect(() => {
        if (process.env.BUILD_TARGET === "server" || !showPopup || !embeddedFbPost) {
            return;
        }
        const onMessage = (e: MessageEvent) => {
            if (!FB_ORIGIN_RE.test(e.origin)) {
                return;
            }
            const reported = parseFacebookPluginResizeHeight(e.data);
            if (reported == null || reported < 60) {
                return;
            }
            const fromOurIframe = messageSourceFromOurFacebookIframe(e.source, facebookPostIframeRef.current);
            if (!fromOurIframe && reported < FB_RELAXED_MIN_PARSED_HEIGHT) {
                return;
            }
            const next = Math.ceil(reported + FB_EMBED_PAD_PX);
            facebookResizeMaxRef.current = Math.max(facebookResizeMaxRef.current, next);
            setFacebookIframeHeight((prev) => Math.max(prev, facebookResizeMaxRef.current));
        };
        window.addEventListener("message", onMessage);
        return () => window.removeEventListener("message", onMessage);
    }, [showPopup, embeddedFbPost]);

    useEffect(() => {
        if (process.env.BUILD_TARGET === "server" || !showPopup || !embeddedFbPost) {
            return;
        }
        const id = window.setTimeout(() => {
            setFacebookIframeHeight((h) => {
                if (facebookResizeMaxRef.current >= FB_EMBED_URL_HEIGHT_HINT + 30) {
                    return Math.max(h, facebookResizeMaxRef.current);
                }
                return Math.min(Math.max(h, 720), Math.floor(window.innerHeight * 0.75));
            });
        }, 2800);
        return () => clearTimeout(id);
    }, [showPopup, embeddedFbPost]);

    useEffect(() => {
        if (process.env.BUILD_TARGET !== "server") {
            const urlParams = new URLSearchParams(window.location.search);
            const vyhladatParam = urlParams.get('vyhladat');
            if (vyhladatParam) {
                setShowSearchPopup(true);
                console.log('vyhladatParam', vyhladatParam);
            }
        }
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (process.env.BUILD_TARGET !== "server") {
                const innerDiv = document.querySelector('.inner') as HTMLElement;   
                if (innerDiv) {
                    innerDiv.style.marginTop = `${window.scrollY}px`;
                }
            }
        };
        const handleKeyUp = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                closePopup();
            }          
        };       

        if (process.env.BUILD_TARGET !== "server") {
            window.addEventListener('keyup', handleKeyUp);
            window.addEventListener('scroll', handleScroll);
        }
        return () => {
            if (process.env.BUILD_TARGET !== "server") {
                window.removeEventListener('scroll', handleScroll);
                window.removeEventListener('keyup', handleKeyUp);
            }
        };
       
    }, []);
    


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("https://www.teraz.sk/api/social_network_content/list.php");
        const data = await response.json();
        setSocialData(data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    fetchYtByViews(0);
    fetchYtByDate(0);
    fetchSpotifyByDate(0);
    fetchInstagramByDate(0);
    fetchFacebookByDate(0);
    fetchFacebookByStateInstitution(0);
    fetchYtByDateNonParlamentary(0);
    fetchFacebookByDateNonParlamentary(0);
    fetchInstagramByDateNonParlamentary(0);
  }, []);

    const formatDate = (dateString: string): string => {
        const date = new Date(dateString);
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);

        // Format time as H:i
        const timeString = date.toLocaleTimeString('sk-SK', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });

        if (date.toDateString() === today.toDateString()) {
            return `dnes ${timeString}`;
        } else if (date.toDateString() === yesterday.toDateString()) {
            return `včera ${timeString}`;
        } else {
            return date.toLocaleString('sk-SK', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            });
        }
    };
  

    function openEmbedPopup(url: string, networkType: string): void {    
        switch (networkType) {
            case 'FACEBOOK':
            case 'STATE_INSTITUTION':
            case 'POLITICAL_PARTY':
                setEmbeddedFbPost(url);
                break;
            case 'INSTAGRAM':
                setEmbeddedIgPost(url);
                break;
            case 'YOUTUBE':
                setEmbeddedYtPost(url);
                break;
            case 'SPOTIFY':
                setEmbeddedSpotifyPost(url);
                break;
            default:
                break;
        }
        setShowPopup(true);
        if (process.env.BUILD_TARGET !== "server") {
            const innerDiv = document.querySelector('.inner') as HTMLElement;
            if (innerDiv) {
                innerDiv.style.marginTop = `${window.scrollY}px`;
            }
        }
    }

    

    function closePopup(): void {        
        setEmbeddedFbPost('');
        setEmbeddedIgPost('');
        setEmbeddedYtPost('');
        setEmbeddedSpotifyPost('');
        setShowPopup(false);
        setShowSearchPopup(false);
    }

    


    function handleFilterToggle(item: string): void {
        setActivePostFilter(item);
    }    
    function handleVideoFilterToggle(item: string): void {
        setActiveVideoFilter(item);
    }    

    const handleSearch = async (searchQuery) => {
        try {
            const response = await fetch(`https://www.teraz.sk/api/social_network_content/list.php?q=${searchQuery}`);
            const data = await response.json();
            
            setSearchTerm(searchQuery);

            // remove youtube from results

            delete data.YOUTUBE;            

            const flatResults = Object.entries(data).reduce((acc, [networkType, items]) => 
                acc.concat(items.by_date.map(item => ({
                    ...item,
                    networkType
                }))), []
            );

            

            setSearchResults(flatResults);
        } catch (error) {
            console.error(error);
        }
    };

    const handleSearchNonParlamentary = async (searchQuery) => {
        try {
            const response = await fetch(`https://www.teraz.sk/api/social_network_content/list.php?q=${searchQuery}`);
            const data = await response.json();
            
            setSearchTermNonParlamentary(searchQuery);

            // remove youtube from results

            delete data.YOUTUBE;            

            const flatResults = Object.entries(data).reduce((acc, [networkType, items]) => 
                acc.concat(items.by_date.map(item => ({
                    ...item,
                    networkType
                }))), []
            );

            

            setSearchResultsNonParlamentary(flatResults);
        } catch (error) {
            console.error(error);
        }
    };

    const handleSearchVideo = async (searchQuery) => {
        try {
            const response = await fetch(`https://www.teraz.sk/api/social_network_content/list.php?q=${searchQuery}`);
            const data = await response.json();
            
            setSearchVideoTerm(searchQuery);

            const flatResults = data.YOUTUBE?.by_date?.map(item => ({
                ...item,
                networkType: "YOUTUBE"
            }))


            setSearchVideoResults(flatResults);
        } catch (error) {
            console.error(error);
        }
    };

    

    const getPageData = (pageIdx: number): Promise<any> => {
        if (pageCache.current.has(pageIdx)) {
            return Promise.resolve(pageCache.current.get(pageIdx));
        }
        if (pendingFetches.current.has(pageIdx)) {
            return pendingFetches.current.get(pageIdx);
        }
        const promise = fetch(`https://www.teraz.sk/api/social_network_content/list.php?pageIdx=${pageIdx}`)
            .then(r => r.json())
            .then(data => {
                pageCache.current.set(pageIdx, data);
                pendingFetches.current.delete(pageIdx);
                return data;
            })
            .catch(err => {
                pendingFetches.current.delete(pageIdx);
                throw err;
            });
        pendingFetches.current.set(pageIdx, promise);
        return promise;
    };

    const fetchYtByViews = async (page: number) => {
        setYtByViewsLoading(true);
        try {
            const data = await getPageData(page);
            const newItems = data.YOUTUBE?.by_views || [];
            setYtByViews(prev => [...prev, ...newItems]);
            setYtByViewsHasMore(newItems.length > 0);
            setYtByViewsPage(page);
        } catch { setYtByViewsHasMore(false); }
        setYtByViewsLoading(false);
    };

    const fetchYtByDate = async (page: number) => {
        setYtByDateLoading(true);
        try {
            const data = await getPageData(page);
            const newItems = data.YOUTUBE?.by_date || [];
            setYtByDate(prev => [...prev, ...newItems]);
            setYtByDateHasMore(newItems.length > 0);
            setYtByDatePage(page);
        } catch { setYtByDateHasMore(false); }
        setYtByDateLoading(false);
    };

    const fetchSpotifyByDate = async (page: number) => {
        setSpotifyByDateLoading(true);
        try {
            const data = await getPageData(page);
            const newItems = data.SPOTIFY?.by_date || [];
            setSpotifyByDate(prev => [...prev, ...newItems]);
            setSpotifyByDateHasMore(newItems.length > 0);
            setSpotifyByDatePage(page);
        } catch { setSpotifyByDateHasMore(false); }
        setSpotifyByDateLoading(false);
    };

    const fetchInstagramByDate = async (page: number) => {
        setInstagramByDateLoading(true);
        try {
            const data = await getPageData(page);
            const newItems = data.INSTAGRAM?.by_date || [];
            setInstagramByDate(prev => [...prev, ...newItems]);
            setInstagramByDateHasMore(newItems.length > 0);
            setInstagramByDatePage(page);
        } catch { setInstagramByDateHasMore(false); }
        setInstagramByDateLoading(false);
    };

    const fetchFacebookByDate = async (page: number) => {
        setFacebookByDateLoading(true);
        try {
            const data = await getPageData(page);
            const newItems = data.FACEBOOK?.POLITICAL_PARTY?.by_date || [];
            setFacebookByDate(prev => [...prev, ...newItems]);
            setFacebookByDateHasMore(newItems.length > 0);
            setFacebookByDatePage(page);
        } catch { setFacebookByDateHasMore(false); }
        setFacebookByDateLoading(false);
    };

    const fetchFacebookByStateInstitution = async (page: number) => {
        setFacebookByStateInstitutionLoading(true);
        try {
            const data = await getPageData(page);
            const newItems = data.FACEBOOK?.STATE_INSTITUTION?.by_date || [];
            setFacebookByStateInstitution(prev => [...prev, ...newItems]);
            setFacebookByStateInstitutionHasMore(newItems.length > 0);
            setFacebookByStateInstitutionPage(page);
        } catch { setFacebookByStateInstitutionHasMore(false); }
        setFacebookByStateInstitutionLoading(false);
    };

    const fetchYtByDateNonParlamentary = async (page: number) => {
        setYoutubeByDateNonParlamentaryLoading(true);
        try {
            const data = await getPageData(page);
            const newItems = (data.YOUTUBE?.NON_PARLIAMENT_SUBJECT?.by_date || []).filter(item => item.network_type === 'YOUTUBE');
            setYoutubeByDateNonParlamentary(prev => [...prev, ...newItems]);
            setYoutubeByDateNonParlamentaryHasMore(newItems.length > 0);
            setYoutubeByDateNonParlamentaryPage(page);
        } catch { setYoutubeByDateNonParlamentaryHasMore(false); }
        setYoutubeByDateNonParlamentaryLoading(false);
    };

    const fetchFacebookByDateNonParlamentary = async (page: number) => {
        setFacebookByDateNonParlamentaryLoading(true);
        try {
            const data = await getPageData(page);
            const newItems = (data.FACEBOOK?.NON_PARLIAMENT_SUBJECT?.by_date || []).filter(item => item.network_type === 'FACEBOOK');
            setFacebookByDateNonParlamentary(prev => [...prev, ...newItems]);
            setFacebookByDateNonParlamentaryHasMore(newItems.length > 0);
            setFacebookByDateNonParlamentaryPage(page);
        } catch { setFacebookByDateNonParlamentaryHasMore(false); }
        setFacebookByDateNonParlamentaryLoading(false);
    };

    const fetchInstagramByDateNonParlamentary = async (page: number) => {
        setInstagramByDateNonParlamentaryLoading(true);
        try {
            const data = await getPageData(page);
            const newItems = (data.INSTAGRAM?.NON_PARLIAMENT_SUBJECT?.by_date || []).filter(item => item.network_type === 'INSTAGRAM');
            setInstagramByDateNonParlamentary(prev => [...prev, ...newItems]);
            setInstagramByDateNonParlamentaryHasMore(newItems.length > 0);
            setInstagramByDateNonParlamentaryPage(page);
        } catch { setInstagramByDateNonParlamentaryHasMore(false); }
        setInstagramByDateNonParlamentaryLoading(false);
    };

    useEffect(() => {
        const handleScroll = () => {
            const viewsEl = ytByViewsRef.current;
            const dateEl = ytByDateRef.current;
            const spotifyEl = spotifyByDateRef.current;
            const instagramEl = instagramByDateRef.current;
            const facebookEl = facebookByDateRef.current;
            const facebookStateInstitutionEl = facebookByStateInstitutionRef.current;
            const youtubeNonParlEl = youtubeByDateNonParlamentaryRef.current;
            const facebookNonParlEl = facebookByDateNonParlamentaryRef.current;
            const instagramNonParlEl = instagramByDateNonParlamentaryRef.current;

            if (viewsEl && !ytByViewsLoading && ytByViewsHasMore && viewsEl.scrollTop + viewsEl.clientHeight >= viewsEl.scrollHeight - 10) {
                fetchYtByViews(ytByViewsPage + 1);
            }
            if (dateEl && !ytByDateLoading && ytByDateHasMore && dateEl.scrollTop + dateEl.clientHeight >= dateEl.scrollHeight - 10) {
                fetchYtByDate(ytByDatePage + 1);
            }
            if (spotifyEl && !spotifyByDateLoading && spotifyByDateHasMore && spotifyEl.scrollTop + spotifyEl.clientHeight >= spotifyEl.scrollHeight - 10) {
                fetchSpotifyByDate(spotifyByDatePage + 1);
            }
            if (instagramEl && !instagramByDateLoading && instagramByDateHasMore && instagramEl.scrollTop + instagramEl.clientHeight >= instagramEl.scrollHeight - 10) {
                fetchInstagramByDate(instagramByDatePage + 1);
            }
            if (facebookEl && !facebookByDateLoading && facebookByDateHasMore && facebookEl.scrollTop + facebookEl.clientHeight >= facebookEl.scrollHeight - 10) {
                fetchFacebookByDate(facebookByDatePage + 1);
            }
            if (facebookStateInstitutionEl && !facebookByStateInstitutionLoading && facebookByStateInstitutionHasMore && facebookStateInstitutionEl.scrollTop + facebookStateInstitutionEl.clientHeight >= facebookStateInstitutionEl.scrollHeight - 10) {
                fetchFacebookByStateInstitution(facebookByStateInstitutionPage + 1);
            }
            if (youtubeNonParlEl && !youtubeByDateNonParlamentaryLoading && youtubeByDateNonParlamentaryHasMore && youtubeNonParlEl.scrollTop + youtubeNonParlEl.clientHeight >= youtubeNonParlEl.scrollHeight - 10) {
                fetchYtByDateNonParlamentary(youtubeByDateNonParlamentaryPage + 1);
            }
            if (facebookNonParlEl && !facebookByDateNonParlamentaryLoading && facebookByDateNonParlamentaryHasMore && facebookNonParlEl.scrollTop + facebookNonParlEl.clientHeight >= facebookNonParlEl.scrollHeight - 10) {
                fetchFacebookByDateNonParlamentary(facebookByDateNonParlamentaryPage + 1);
            }
            if (instagramNonParlEl && !instagramByDateNonParlamentaryLoading && instagramByDateNonParlamentaryHasMore && instagramNonParlEl.scrollTop + instagramNonParlEl.clientHeight >= instagramNonParlEl.scrollHeight - 10) {
                fetchInstagramByDateNonParlamentary(instagramByDateNonParlamentaryPage + 1);
            }
        };

        const els = [
            ytByViewsRef, ytByDateRef, spotifyByDateRef, instagramByDateRef,
            facebookByDateRef, facebookByStateInstitutionRef,
            youtubeByDateNonParlamentaryRef, facebookByDateNonParlamentaryRef, instagramByDateNonParlamentaryRef,
        ].map(r => r.current);

        els.forEach(el => el && el.addEventListener('scroll', handleScroll));
        return () => els.forEach(el => el && el.removeEventListener('scroll', handleScroll));
    }, [
        ytByViewsLoading, ytByViewsHasMore, ytByViewsPage,
        ytByDateLoading, ytByDateHasMore, ytByDatePage,
        spotifyByDateLoading, spotifyByDateHasMore, spotifyByDatePage,
        instagramByDateLoading, instagramByDateHasMore, instagramByDatePage,
        facebookByDateLoading, facebookByDateHasMore, facebookByDatePage,
        facebookByStateInstitutionLoading, facebookByStateInstitutionHasMore, facebookByStateInstitutionPage,
        youtubeByDateNonParlamentaryLoading, youtubeByDateNonParlamentaryHasMore, youtubeByDateNonParlamentaryPage,
        facebookByDateNonParlamentaryLoading, facebookByDateNonParlamentaryHasMore, facebookByDateNonParlamentaryPage,
        instagramByDateNonParlamentaryLoading, instagramByDateNonParlamentaryHasMore, instagramByDateNonParlamentaryPage,
    ]);

  return (
    <div>
        <div className="container static-page ass">  
            <div className="text-center">
                <h1>Politika na sociálnych sieťach</h1>
            </div>                          
            
            {showSearchPopup && (process.env.BUILD_TARGET !== "server") &&
            <div className="search-popup">
                <div className="inner" style={{ marginTop: `${window.scrollY}px` }}>
                    <div className="close-popup" onClick={() => setShowSearchPopup(false)}>Zavrieť</div>
                    <div className="search-group first">
                        <div className="subtitle">Vyhľadajte vo videách</div>
                        <form className="search-form"
                            onSubmit={(e) => {
                                e.preventDefault();
                                const searchQuery = e.target.elements['search-yt'].value;
                                handleSearchVideo(searchQuery);
                                setShowSearchPopup(false);
                                if (process.env.BUILD_TARGET !== "server") {
                                    window.scrollTo({
                                        top: document.querySelector('.anch-videos')?.offsetTop - 100,
                                        behavior: 'smooth'
                                    });
                                }
                            }}
                        >
                            <input type="text" name="search-yt" placeholder="Hľadaný výraz" id="" />
                            <button type="submit">
                                <i className="icon icon-search light sm"></i>
                            </button>
                        </form>
                    </div>                    

                    <div className="search-group">
                        <div className="subtitle">Vyhľadajte v príspevkoch</div>
                        <form className="search-form"
                            onSubmit={(e) => {
                                e.preventDefault();
                                const searchQuery = e.target.elements['search-posts'].value;
                                handleSearch(searchQuery);
                                setShowSearchPopup(false);
                                if (process.env.BUILD_TARGET !== "server") {
                                    window.scrollTo({
                                        top: document.querySelector('.anch-posts')?.offsetTop - 100,
                                        behavior: 'smooth'
                                    });
                                }
                            }}
                        >
                            <input type="text" name="search-posts" placeholder="Hľadaný výraz" id="" />
                            <button type="submit">
                                <i className="icon icon-search light sm"></i>
                            </button>
                        </form>
                    </div>
                </div>
            </div>
            }
            
            {showPopup && (process.env.BUILD_TARGET !== "server") &&
            <div className={"embedded-post-popup " + (embeddedFbPost && 'fb-post')}>
                <div className="inner" style={{ marginTop: `${window.scrollY}px` }}>
                    <div className="close-popup" onClick={() => closePopup()}>Zavrieť</div>
                    {embeddedFbPost && (
                        <>
                            <div className="facebook-embed-modal-scroll">
                                <div className="social-embed-wrap social-embed-wrap--facebook">
                                    {facebookPostPlugin && (
                                        <iframe
                                            key={embeddedFbPost}
                                            ref={facebookPostIframeRef}
                                            title="Facebook príspevok"
                                            src={facebookPostPlugin.src}
                                            width={facebookPostPlugin.width}
                                            height={facebookIframeHeight}
                                            style={{ border: "none", width: "100%", maxWidth: "100%", display: "block" }}
                                            scrolling="yes"
                                            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                                            className="facebook-embed-iframe"
                                        />
                                    )}
                                </div>
                            </div>
                            <div className="social-embed-open-link">
                                <a href={embeddedFbPost} target="_blank" rel="noopener noreferrer">
                                    Otvoriť celý príspevok na Facebooku
                                </a>
                            </div>

                        </>
                    )}
                    {embeddedIgPost && (
                        <div className="social-embed-wrap">
                            <InstagramEmbed url={embeddedIgPost} width={"100%"} />
                        </div>
                    )}
                    {embeddedYtPost && (
                        <div className="social-embed-wrap">
                            <YouTubeEmbed url={embeddedYtPost} width={"100%"} />
                        </div>
                    )}
                    {embeddedSpotifyPost && <div id="spotify-player"><SpotifyPlayer embedUrl={embeddedSpotifyPost} /></div>}
                </div>                  
            </div>
            }
            
            <div className="ass-page-wrapper ass-2-cols">
                <div className="row-ass">
                    <div className="col-ass">
                        <div className="top-col">
                            <i className="icon icon-yt"></i>
                            <div className="text">
                                <div className="title">YouTube - Najsledovanejšie videá</div>
                                {/* <div className="desc">za posledných 24 hodín</div> */}
                                <div className="desc">za posledných 7 dní</div>
                            </div>
                        </div>

                        <div className="ass-banner-list" ref={ytByViewsRef}>
                            {ytByViews.map((item, index) => (
                                <div className="ass-banner-item yt" onClick={() => openEmbedPopup(item.url, item.network_type)} key={index}>
                                    <div
                                        className={`img-wrapper ${item.thumbnail == '' ? 'no-img' : ''}`}
                                        style={{ backgroundImage: `url(${item.thumbnail})` }}
                                    ></div>
                                    <div className="text">
                                        <div className="title xl">
                                            {item.title && item.title.length > 0 ? (item.title.length > 55 ? item.title.substring(0, 55) + "..." : item.title) : item.creator_name}
                                        </div>
                                        <div className="meta"> {formatDate(item.remote_created)} | {item.creator_handle} | {item.views} zobrazení</div>
                                    </div>
                                </div>
                            ))}
                            {ytByViewsLoading && <div className="item-list-loading">Načítavam...</div>}
                        </div>
                    </div>

                    <div className="col-ass">
                    <div className="top-col">
                        <i className="icon icon-yt"></i>
                        <div className="text">
                            <div className="title">YouTube - Najnovšie videá</div>
                        </div>
                    </div>

                    <div className="ass-banner-list" ref={ytByDateRef}>
                        {ytByDate.map((item, index) => (
                            <div className="ass-banner-item yt" onClick={() => openEmbedPopup(item.url, item.network_type)} key={index}>
                                <div
                                    className={`img-wrapper ${item.thumbnail == '' ? 'no-img' : ''}`}
                                    style={{ backgroundImage: `url(${item.thumbnail})` }}
                                ></div>
                                <div className="text">
                                    <div className="title xl">
                                        {item.title && item.title.length > 0 ? (item.title.length > 55 ? item.title.substring(0, 55) + "..." : item.title) : item.creator_name}
                                    </div>
                                    <div className="meta"> {formatDate(item.remote_created)} | {item.creator_handle} | {item.views} zobrazení</div>
                                </div>
                            </div>
                        ))}
                        {ytByDateLoading && <div className="item-list-loading">Načítavam...</div>}
                    </div>
                </div>  
                </div>                

                

                <div className="anch-videos"></div>
                <div className="col-search-bar">
                    <div className="title">
                        <i className="icon icon-search"></i>
                        <span>Vyhľadávanie vo videách</span>
                    </div>
                    <form
                        className="search-form"
                        onSubmit={(e) => {
                            e.preventDefault();
                            const searchQuery = e.target.elements['search-yt'].value;
                            handleSearchVideo(searchQuery);
                        }}
                    >
                        <div className="input-wrapper">
                            <input type="text" name="search-yt" placeholder="Hľadaný výraz" id="" />
                            <button type="submit">
                                <i className="icon icon-search sm"></i>
                            </button>
                        </div>
                    </form>

                    <ul className="filter-bar">
                        <li>
                            <div
                                className={`filter-toggle ${activeVideoFilter === "last3days" ? "active" : ""}`}
                                onClick={() => handleVideoFilterToggle("last3days")}
                            >
                                Posledné 3 dni
                            </div>
                        </li>
                        <li>
                            <div
                                className={`filter-toggle ${activeVideoFilter === "lastweek" ? "active" : ""}`}
                                onClick={() => handleVideoFilterToggle("lastweek")}
                            >
                                Posledný týždeň
                            </div>
                        </li>
                        <li>
                            <div
                                className={`filter-toggle ${activeVideoFilter === "lastmonth" ? "active" : ""}`}
                                onClick={() => handleVideoFilterToggle("lastmonth")}
                            >
                                Posledný mesiac
                            </div>
                        </li>
                    </ul>
                </div>

                { searchVideoTerm != '' &&
                <div className="ass-search-results-wrapper">
                    <div className="title">Výsledky vyhľadávania pre výraz "{searchVideoTerm}":</div>

                    { searchVideoResults.length > 0 ? (
                    <div className="search-results-list">
                    
                        {searchVideoResults.map((item, index) => (
                                <div 
                                    onClick={() => openEmbedPopup(item.url, item.networkType)}
                                    className={'search-result-item ' + item.networkType} key={index}>
                                    <div
                                        className={`img-wrapper ${item.thumbnail == '' ? 'no-img' : ''}`}
                                        style={{ backgroundImage: `url(${item.thumbnail})` }}
                                    ></div>
                                    <div className="text">
                                        <div className="title">
                                            {item.title.length > 120
                                                ? item.title.substring(0, 120) + '...'
                                                : item.title}
                                        </div>
                                        {item.text_content && (
                                            <div className="desc">
                                                {item.text_content.length > 120
                                                    ? item.text_content.substring(0, 120) + '...'
                                                    : item.text_content}
                                            </div>
                                        )}
                                    </div>
                                </div>
                        ))}
                    </div>
                    ): (
                        <div>
                            Ľutujeme, nenašli sa žiadne výsledky pre Váš hľadaný výraz.
                        </div>
                    )}
                
                </div>                
                }
                              
            </div>                    

            <div className="ass-page-wrapper first ass-4-cols">
                <div className="row-ass">
                    {/* <div className="col-ass">
                        <div className="top-col">
                            <i className="icon icon-spotify"></i>
                            <div className="text">
                                <div className="title">Spotify</div>
                                <div className="desc">Najnovšie podcasty</div>
                            </div>
                        </div>

                        <div className="ass-banner-list bg" ref={spotifyByDateRef}>
                            {spotifyByDate.map((item, index) => (
                                    <div className="ass-banner-item sm" onClick={() => openEmbedPopup(item.social_network_id, item.network_type)} key={index}>
                                    <div
                                        className={`img-wrapper circle ${item.thumbnail == '' ? 'no-img' : ''}`}
                                        style={{ backgroundImage: `url(${item.thumbnail})` }}
                                    ></div>
                                    <div className="text">
                                        <div className="title">
                                            {item.title.length > 55 ? item.title.substring(0, 55) + "..." : item.title}
                                        </div>
                                    </div>
                                    </div>
                                ))}
                            {spotifyByDateLoading && <div className="item-list-loading">Načítavam...</div>}
                        </div>                        

                    </div> */}

                    {/* <div className="col-ass">
                        <div className="top-col">
                            <i className="icon icon-threads"></i>
                            <div className="text">
                                <div className="title">Najnovšie statusy</div>
                            </div>
                        </div>

                        <div className="ass-banner-list bg">
                            {socialData?.THREADS?.by_date?.slice(0, 6).map((item, index) => (
                                <div className="ass-banner-item sm" onClick={() => openEmbedPopup(item.url, item.network_type)} key={index}>
                                <div
                                    className={`img-wrapper ${item.thumbnail == '' ? 'no-img' : ''}`}
                                    style={{ backgroundImage: `url(${item.thumbnail})` }}
                                ></div>
                                <div className="text">
                                    <div className="title">
                                        {item.title.length > 55 ? item.title.substring(0, 55) + "..." : item.title}
                                    </div>
                                </div>
                                </div>
                            ))}
                        </div>

                    </div> */}
                    
                    <div className="col-ass">
                        <div className="top-col icon-top">
                            <i className="icon icon-fb"></i>
                            <div className="text">
                                <div className="title">Facebook</div>
                                {/* <div className="desc">Najnovšie statusy</div> */}
                                <div className="desc">Najnovšie politické statusy</div>
                            </div>
                        </div>

                        <div className="ass-banner-list bg" ref={facebookByDateRef}>
                            {facebookByDate.map((item, index) => (
                                <div className="ass-banner-item sm" onClick={() => openEmbedPopup(item.url, item.network_type)} key={index}>
                                    <div
                                        className={`img-wrapper ${item.thumbnail == '' ? 'no-img' : ''}`}
                                        style={{ backgroundImage: `url(${item.thumbnail})` }}
                                    ></div>
                                    <div className="text">
                                        <div className="profile-name">{item.creator_handle}</div>
                                        <div className="title">
                                        {item.title && item.title.length > 0 ? (item.title.length > 55 ? item.title.substring(0, 55) + "..." : item.title) : item.creator_name}
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {facebookByDateLoading && <div className="item-list-loading">Načítavam...</div>}
                        </div>
                    </div>

                    <div className="col-ass">
                        <div className="top-col icon-top">
                            <i className="icon icon-fb"></i>
                            <div className="text">
                                <div className="title">Facebook</div>
                                <div className="desc">Najnovšie statusy štátnych inštitúcií</div>
                            </div>
                        </div>

                        <div className="ass-banner-list bg" ref={facebookByStateInstitutionRef}>
                            {facebookByStateInstitution.map((item, index) => (
                                <div className="ass-banner-item sm" onClick={() => openEmbedPopup(item.url, item.network_type)} key={index}>
                                    <div
                                        className={`img-wrapper ${item.thumbnail == '' ? 'no-img' : ''}`}
                                        style={{ backgroundImage: `url(${item.thumbnail})` }}
                                    ></div>
                                    <div className="text">
                                        <div className="profile-name">{item.creator_handle}</div>
                                        <div className="title">
                                        {item.title && item.title.length > 0 ? (item.title.length > 55 ? item.title.substring(0, 55) + "..." : item.title) : item.creator_name}
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {facebookByStateInstitutionLoading && <div className="item-list-loading">Načítavam...</div>}
                        </div>
                    </div>
                    

                    <div className="col-ass">
                        <div className="top-col icon-top">
                            <i className="icon icon-ig"></i>
                            <div className="text">
                                <div className="title">Instagram</div>
                                <div className="desc">Najnovšie príspevky</div>
                            </div>
                        </div>

                        <div className="ass-banner-list bg" ref={instagramByDateRef}>
                            {instagramByDate.map((item, index) => (
                                <div className="ass-banner-item sm" onClick={() => openEmbedPopup(item.url, item.network_type)} key={index}>
                                <div
                                    className={`img-wrapper ${item.thumbnail == '' ? 'no-img' : ''}`}
                                    style={{ backgroundImage: `url(${item.thumbnail})` }}
                                ></div>
                                <div className="text">
                                    <div className="profile-name">@{item.creator_handle}</div>
                                    <div className="title">
                                        {item.title.length > 55 ? item.title.substring(0, 55) + "..." : item.title}
                                    </div>
                                </div>
                                </div>
                            ))}
                            {instagramByDateLoading && <div className="item-list-loading">Načítavam...</div>}
                        </div>

                    </div>
                </div>

                <div className="anch-posts"></div>
                <div className="col-search-bar">
                    <div className="title">
                        <i className="icon icon-search"></i>
                        <span>Vyhľadávanie v príspevkoch</span>
                    </div>
                        <form
                            className="search-form"
                            onSubmit={(e) => {
                                e.preventDefault();
                                const searchQuery = e.target.elements['search-posts'].value;
                                handleSearch(searchQuery);
                            }}
                        >
                            <div className="input-wrapper">
                                <input type="text" name="search-posts" placeholder="Hľadaný výraz" id="" />
                                <button type="submit">
                                    <i className="icon icon-search sm"></i>
                                </button>
                            </div>
                        </form>

                    <ul className="filter-bar">
                        <li>
                            <div
                                className={`filter-toggle ${activePostFilter === "last3days" ? "active" : ""}`}
                                onClick={() => handleFilterToggle("last3days")}
                            >
                                Posledné 3 dni
                            </div>
                        </li>
                        <li>
                            <div
                                className={`filter-toggle ${activePostFilter === "lastweek" ? "active" : ""}`}
                                onClick={() => handleFilterToggle("lastweek")}
                            >
                                Posledný týždeň
                            </div>
                        </li>
                        <li>
                            <div
                                className={`filter-toggle ${activePostFilter === "lastmonth" ? "active" : ""}`}
                                onClick={() => handleFilterToggle("lastmonth")}
                            >
                                Posledný mesiac
                            </div>
                        </li>
                    </ul>
                </div>

                { searchTerm != '' &&
                <div className="ass-search-results-wrapper">
                    <div className="title">Výsledky vyhľadávania pre výraz "{searchTerm}":</div>

                    { searchResults.length > 0 ? (
                    <div className="search-results-list">
                    
                        {searchResults.map((item, index) => (                                
                            <div
                                onClick={() => openEmbedPopup(item.url, item.networkType)}
                                className={'search-result-item ' + item.networkType} key={index}>
                                <div
                                    className={`img-wrapper ${item.thumbnail == '' ? 'no-img' : ''}`}
                                    style={{ backgroundImage: `url(${item.thumbnail})` }}
                                ></div>
                                <div className="text">
                                    <div className="title">
                                        {item.title.length > 120
                                            ? item.title.substring(0, 120) + '...'
                                            : item.title}
                                    </div>
                                    {item.text_content && (
                                        <div className="desc">
                                            {item.text_content.length > 120
                                                ? item.text_content.substring(0, 120) + '...'
                                                : item.text_content}
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                    ): (
                        <div>
                            Ľutujeme, nenašli sa žiadne výsledky pre Váš hľadaný výraz.
                        </div>
                    )}
                
                </div>                
                }

            </div>

            <div className="ass-page-wrapper ass-4-cols">
                <div className="row-ass">                    
                    
                    <div className="col-ass">
                        <div className="top-col icon-top">
                            <i className="icon icon-yt"></i>
                            <div className="text">
                                <div className="title">YouTube - Najnovšie videá</div>                                
                                <div className="desc">Najnovšie politické statusy</div>                                
                                <div className="subtitle">Mimoparlamentné subjekty</div>
                            </div>
                        </div>

                        <div className="ass-banner-list bg" ref={youtubeByDateNonParlamentaryRef}>
                            {youtubeByDateNonParlamentary.map((item, index) => (
                                <div className="ass-banner-item sm" onClick={() => openEmbedPopup(item.url, item.network_type)} key={index}>
                                    <div
                                        className={`img-wrapper ${item.thumbnail == '' ? 'no-img' : ''}`}
                                        style={{ backgroundImage: `url(${item.thumbnail})` }}
                                    ></div>
                                    <div className="text">
                                        <div className="profile-name">{item.creator_handle}</div>
                                        <div className="title">
                                        {item.title && item.title.length > 0 ? (item.title.length > 55 ? item.title.substring(0, 55) + "..." : item.title) : item.creator_name}
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {youtubeByDateNonParlamentaryLoading && <div className="item-list-loading">Načítavam...</div>}
                            {!youtubeByDateNonParlamentaryLoading && youtubeByDateNonParlamentary.length === 0 && <div className="item-list-loading">Nenašli sa žiadne príspevky</div>}
                        </div>
                    </div>

                    <div className="col-ass">
                        <div className="top-col icon-top">
                            <i className="icon icon-fb"></i>
                            <div className="text">
                                <div className="title">Facebook</div>                                
                                <div className="desc">Najnovšie statusy štátnych inštitúcií</div>                                
                                <div className="subtitle">Mimoparlamentné subjekty</div>
                            </div>
                        </div>

                        <div className="ass-banner-list bg" ref={facebookByDateNonParlamentaryRef}>
                            {facebookByDateNonParlamentary.map((item, index) => (
                                <div className="ass-banner-item sm" onClick={() => openEmbedPopup(item.url, item.network_type)} key={index}>
                                    <div
                                        className={`img-wrapper ${item.thumbnail == '' ? 'no-img' : ''}`}
                                        style={{ backgroundImage: `url(${item.thumbnail})` }}
                                    ></div>
                                    <div className="text">
                                        <div className="profile-name">{item.creator_handle}</div>
                                        <div className="title">
                                        {item.title && item.title.length > 0 ? (item.title.length > 55 ? item.title.substring(0, 55) + "..." : item.title) : item.creator_name}
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {facebookByDateNonParlamentaryLoading && <div className="item-list-loading">Načítavam...</div>}
                            {!facebookByDateNonParlamentaryLoading && facebookByDateNonParlamentary.length === 0 && <div className="item-list-loading">Nenašli sa žiadne príspevky</div>}
                        </div>
                    </div>
                    

                    <div className="col-ass">
                        <div className="top-col icon-top">
                            <i className="icon icon-ig"></i>
                            <div className="text">
                                <div className="title">Instagram</div>                                
                                <div className="desc">Najnovšie príspevky</div>                                
                                <div className="subtitle">Mimoparlamentné subjekty</div>
                            </div>
                        </div>

                        <div className="ass-banner-list bg" ref={instagramByDateNonParlamentaryRef}>
                            {instagramByDateNonParlamentary.map((item, index) => (
                                <div className="ass-banner-item sm" onClick={() => openEmbedPopup(item.url, item.network_type)} key={index}>
                                <div
                                    className={`img-wrapper ${item.thumbnail == '' ? 'no-img' : ''}`}
                                    style={{ backgroundImage: `url(${item.thumbnail})` }}
                                ></div>
                                <div className="text">
                                    <div className="profile-name">@{item.creator_handle}</div>
                                    <div className="title">
                                        {item.title.length > 55 ? item.title.substring(0, 55) + "..." : item.title}
                                    </div>
                                </div>
                                </div>
                            ))}
                            {instagramByDateNonParlamentaryLoading && <div className="item-list-loading">Načítavam...</div>}
                            {!instagramByDateNonParlamentaryLoading && instagramByDateNonParlamentary.length === 0 && <div className="item-list-loading">Nenašli sa žiadne príspevky</div>}
                        </div>

                    </div>
                </div>

                <div className="anch-posts"></div>
                <div className="col-search-bar">
                    <div className="title">
                        <i className="icon icon-search"></i>
                        <span>Vyhľadávanie v príspevkoch</span>
                    </div>
                        <form
                            className="search-form"
                            onSubmit={(e) => {
                                e.preventDefault();
                                const searchQuery = e.target.elements['search-posts-non-parlamentary'].value;
                                handleSearchNonParlamentary(searchQuery);
                            }}
                        >
                            <div className="input-wrapper">
                                <input type="text" name="search-posts-non-parlamentary" placeholder="Hľadaný výraz" id="" />
                                <button type="submit">
                                    <i className="icon icon-search sm"></i>
                                </button>
                            </div>
                        </form>

                    <ul className="filter-bar">
                        <li>
                            <div
                                className={`filter-toggle ${activePostFilter === "last3days" ? "active" : ""}`}
                                onClick={() => handleFilterToggle("last3days")}
                            >
                                Posledné 3 dni
                            </div>
                        </li>
                        <li>
                            <div
                                className={`filter-toggle ${activePostFilter === "lastweek" ? "active" : ""}`}
                                onClick={() => handleFilterToggle("lastweek")}
                            >
                                Posledný týždeň
                            </div>
                        </li>
                        <li>
                            <div
                                className={`filter-toggle ${activePostFilter === "lastmonth" ? "active" : ""}`}
                                onClick={() => handleFilterToggle("lastmonth")}
                            >
                                Posledný mesiac
                            </div>
                        </li>
                    </ul>
                </div>

                { searchTermNonParlamentary != '' &&
                <div className="ass-search-results-wrapper">
                    <div className="title">Výsledky vyhľadávania pre výraz "{searchTermNonParlamentary}":</div>

                    { searchResultsNonParlamentary.length > 0 ? (
                    <div className="search-results-list">
                    
                        {searchResultsNonParlamentary.map((item, index) => (                                
                            <div
                                onClick={() => openEmbedPopup(item.url, item.networkType)}
                                className={'search-result-item ' + item.networkType} key={index}>
                                <div
                                    className={`img-wrapper ${item.thumbnail == '' ? 'no-img' : ''}`}
                                    style={{ backgroundImage: `url(${item.thumbnail})` }}
                                ></div>
                                <div className="text">
                                    <div className="title">
                                        {item.title.length > 120
                                            ? item.title.substring(0, 120) + '...'
                                            : item.title}
                                    </div>
                                    {item.text_content && (
                                        <div className="desc">
                                            {item.text_content.length > 120
                                                ? item.text_content.substring(0, 120) + '...'
                                                : item.text_content}
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                    ): (
                        <div>
                            Ľutujeme, nenašli sa žiadne výsledky pre Váš hľadaný výraz.
                        </div>
                    )}
                
                </div>                
                }

            </div>

            <div className="ass-page-socials">
                <div className="title">Sledujte nás na sociálnych sieťach</div>

                <ul>
                    <li><Link to={tasrTVVideaURL}><i className="icon icon-yt sm"></i><span>TASR TV Videá</span></Link></li>
                    <li><Link to={terazIgURL}><i className="icon icon-ig"></i><span>Teraz.sk</span></Link></li>
                    <li><Link to={tasrIgURL}><i className="icon icon-ig"></i><span>TASR.sk</span></Link></li>
                    {/* <li><Link to={terazThreadsURL}><i className="icon icon-threads"></i><span>Teraz.sk</span></Link></li> */}
                    <li><Link to={TerazFBUrl}><i className="icon icon-fb"></i><span>Teraz.sk</span></Link></li>
                    <li><Link to={tasrFBUrl}><i className="icon icon-fb"></i><span>TASR.sk</span></Link></li>
                    {/* <li><Link to={terazSCURL}><i className="icon icon-sc"></i><span>Teraz.sk</span></Link></li> */}
                </ul>
            </div>

            
           
        </div>
        

      <LoaderIndex />
    </div>
  );
};

export default AgregatorSocSietiPage;